import { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { ArticleFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { ArticleCreateFormContainerProps } from "models/propTypes/articlePropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region components
import ImportArticleForm from "./importForm";
import { useArticleService } from "serviceHooks";
//#endregion
import * as Yup from "yup";

const ImportArticleFormContainer: ForwardRefRenderFunction<FormHandles, ArticleCreateFormContainerProps> = (
  props,
  ref
) => {
  const articleService = useArticleService();

  const validationSchema = Yup.object<ArticleFormTypes.ImportArticle>({
    name: Yup.string().required(TranslationKeys.Validations.Required),
    unit: Yup.string(),
    standardPrice: Yup.string().required(TranslationKeys.Validations.Required),
    vat: Yup.string().required(TranslationKeys.Validations.Required),
    euVatProductType: Yup.string(),
    csvUpload: Yup.array().required(TranslationKeys.Validations.Required),
  });

  const handleSubmit = (values: ArticleFormTypes.ImportArticle) => {
    const uploadedFile = values.csvUpload ? values.csvUpload[0] : undefined;
    const file = uploadedFile
      ? {
          fileName: uploadedFile.fileName,
          contentType: uploadedFile.contentType,
          data: uploadedFile.data,
        }
      : undefined;

    return articleService.importArticles({
      productTextColumn: values.name,
      invoiceUnitsColumn: values.unit,
      unitPriceColumn: values.standardPrice,
      productVATColumn: values.vat,
      eUVATCategoryColumn: values.euVatProductType,
      csvUpload: file,
      delimiter: WintSuperkollAPIModel.CsvImportDelimiter.Comma,
    });
  };

  return (
    <ImportArticleForm
      ref={ref}
      validationSchema={validationSchema}
      handleSubmit={handleSubmit}
      onFormValidationChange={props.onFormValidationChange}
      defaultValues={undefined}
    />
  );
};

export default forwardRef(ImportArticleFormContainer);
